import {GetAssignmentTypes, CreateAssignmentType} from "../../../api/AssignmentTypeApi";
import {AssignmentTypeInputs} from "../../AssigmentType/AssignmentTypeInputs";

export const AssignmentSequenceInputs = [
  { name: 'name', label: "Name", type: 'text', defaultValue: '', validation: { required: "Please enter a name" } },
  { name: 'instructions', label: "Instructions", type: 'text', defaultValue: '', validation: { required: "Please enter some instructions" } },
  { name: 'timeToComplete', label: "Time to Complete (minutes)", type: 'number', defaultValue: 60 },
  {
    name: 'assignmentType',
    label: 'Assignment Type',
    getItems: GetAssignmentTypes,
    optionValue: 'name',
    validation: {
      required: true,
      validate: val => val.name ? true : 'Please choose a type' },
    type: 'autocomplete',
    defaultValue: { name: '' },
    inputs: AssignmentTypeInputs,
    addNew: CreateAssignmentType
  },
  {
    name: 'occurrenceType',
    type: 'hidden',
    defaultValue: 'sequence'
  }
];